import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AlertController, IonList } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import { UsersService } from 'src/app/services/users.service';
import { User } from '../../model/user.model';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent implements OnInit {
  @ViewChild('usersList') usersList: IonList;

  @Input() users: User[] = [];
  @Output() userDeleted = new EventEmitter<string>();

  constructor(
    private userService: UsersService,
    private toastService: ToastService,
    private alertControl: AlertController,
    private router: Router) { }

  ngOnInit() {}

  view(user: User) {
    this.usersList.closeSlidingItems();
    const navigationExtras: NavigationExtras = {
      state: {
        selectedUser: user
      }
    };
    this.router.navigate(['home/users/user'], navigationExtras);
  }

  delete(user: User) {
    this.usersList.closeSlidingItems();
    this.userDeleted.emit(user.id);
  }

  createNewUser() {
    console.log('createNewUser');
    this.router.navigate(['home/users/user']);
  }
}
